module.exports = __webpack_public_path__ + "static/media/tools-and-utensils.554b1054.svg";